"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalTrigger = exports.PopoverTrigger = exports.RatingOverlay = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_popper_1 = require("react-popper");
var RatingSlider_1 = __importDefault(require("../RatingSlider/RatingSlider"));
var AdvancedModal_1 = __importDefault(require("../Modal/AdvancedModal"));
var RatingOverlay = function (props) {
    var children = props.children, ratingStars = props.ratingStars;
    var _a = (0, react_1.useState)(null), popperTriggerRef = _a[0], setPopperTriggerRef = _a[1];
    var _b = (0, react_1.useState)(null), popper = _b[0], setPopper = _b[1];
    var _c = (0, react_1.useState)(false), popoverVisible = _c[0], setPopoverVisible = _c[1];
    var _d = (0, react_1.useState)(false), modalVisible = _d[0], setModalVisible = _d[1];
    var _e = (0, react_popper_1.usePopper)(popperTriggerRef, popper, {
        placement: 'bottom',
        strategy: 'fixed',
    }), styles = _e.styles, update = _e.update;
    var handlePopperTriggerClick = function () {
        setPopoverVisible(!popoverVisible);
        update && update();
    };
    var handleModalTriggerClick = function () {
        setModalVisible(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.PopoverTrigger, { ref: setPopperTriggerRef, onClick: handlePopperTriggerClick }, children),
        react_1.default.createElement(exports.ModalTrigger, { onClick: handleModalTriggerClick }, children),
        popoverVisible && (react_1.default.createElement(Popover, { ref: setPopper, style: styles.popper },
            react_1.default.createElement(RatingSlider_1.default, { className: "rating-slider", userRating: ratingStars.userRating, submitRating: ratingStars.submitRating }))),
        react_1.default.createElement(StyledModal, { show: modalVisible, onClose: function () { return setModalVisible(false); } },
            react_1.default.createElement(StyledSlider, { className: "rating-slider", userRating: ratingStars.userRating, submitRating: ratingStars.submitRating }))));
};
exports.RatingOverlay = RatingOverlay;
var Popover = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  width: 280px;\n  z-index: 10;\n  border-radius: 6px;\n\n  .rating-slider {\n    margin: 42px 24px 12px;\n    width: 228px;\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);\n  width: 280px;\n  z-index: 10;\n  border-radius: 6px;\n\n  .rating-slider {\n    margin: 42px 24px 12px;\n    width: 228px;\n  }\n"])), function (props) { return props.theme.primary1; }, function (props) { return props.theme.primary4; });
var StyledSlider = (0, styled_components_1.default)(RatingSlider_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 32px 12px 12px;\n\n  .rc-slider-dot {\n    background-color: #fff;\n  }\n"], ["\n  margin: 32px 12px 12px;\n\n  .rc-slider-dot {\n    background-color: #fff;\n  }\n"])));
var StyledModal = (0, styled_components_1.default)(AdvancedModal_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 280px;\n"], ["\n  width: 280px;\n"])));
exports.PopoverTrigger = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  cursor: pointer;\n  @media (max-width: 767px) {\n    display: none;\n  }\n"], ["\n  cursor: pointer;\n  @media (max-width: 767px) {\n    display: none;\n  }\n"])));
exports.ModalTrigger = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  cursor: pointer;\n  @media (min-width: 768px) {\n    display: none;\n  }\n"], ["\n  cursor: pointer;\n  @media (min-width: 768px) {\n    display: none;\n  }\n"])));
exports.default = exports.RatingOverlay;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
